export const parseBooleanToText = (isTrue: boolean) =>
    isTrue ? 'Tak' : 'Nie'